import { ClearStoreAction, LoadDataErrorAction, LoadDataRequestAction, LoadDataSuccessAction } from './actions.d';
import actionTypes from './actionTypes';
import { ILoadDataRequestPayload, ILoadDataSuccessPayload } from './types';

const actions = {
  loadDataRequest: (payload: ILoadDataRequestPayload): LoadDataRequestAction => ({
    type: actionTypes.LOAD_DATA_REQUEST,
    payload,
  }),

  loadDataSuccess: (payload: ILoadDataSuccessPayload): LoadDataSuccessAction => ({
    type: actionTypes.LOAD_DATA_SUCCESS,
    payload,
  }),

  loadDataError: (): LoadDataErrorAction => ({
    type: actionTypes.LOAD_DATA_ERROR,
  }),

  clearStore: (): ClearStoreAction => ({
    type: actionTypes.CLEAR_STORE,
  }),
};

export default actions;
